module.exports = __webpack_public_path__ + "img/12-half-lg.eb5b4144.jpg";